export default __webpack_public_path__ + "static/media/brazil_capitals.4a670bca.geojson";